// @ts-nocheck
import React, { useEffect, useState } from "react";
import { GripVertical } from "lucide-react";
import { Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import { useTestRecords } from "app/state/testRecords";
import { columnConfig } from "app/constants/testRecordsConst";
import { cloneDeep } from "lodash";

const styles = {
  container: {
    marginTop: "16px",
    backgroundColor: "white",
  },
  disabledFields: {
    marginLeft: "38px",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px",
    backgroundColor: "white",
    borderRadius: "8px",
    cursor: "move",
    transition: "all 0.2s ease",
    userSelect: "none",
  },
  listItemHover: {
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  listItemDragOver: {
    borderColor: "#60a5fa",
    backgroundColor: "#eff6ff",
  },
  listItemDragging: {
    opacity: 0.5,
  },
  dragHandle: {
    color: "#9ca3af",
    display: "flex",
    alignItems: "center",
    transition: "color 0.2s ease",
  },
  dragHandleHover: {
    color: "#6b7280",
  },
};

const DraggableList = ({ viewId }: any) => {
  const { t } = useTranslation();
  const { handleColumns, views } = useTestRecords();

  const getColumns = () => {
    const view = views?.views?.find(view => view.id === viewId);
    const columns = cloneDeep(view?.columns);
    return columns;
  };

  const [items, setItems] = useState(viewId ? getColumns() : columnConfig);

  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const toggleEnabled = id => {
    setItems(
      items.map(item =>
        item.id === id ? { ...item, enabled: !item.enabled } : item
      )
    );
  };

  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();

    if (!draggedItem) return;

    const dragIndex = items.findIndex(item => item.id === draggedItem.id);

    if (dragIndex === dropIndex) {
      setDraggedItem(null);
      setDragOverIndex(null);
      return;
    }

    const newItems = [...items];
    const [draggedElement] = newItems.splice(dragIndex, 1);
    newItems.splice(dropIndex, 0, draggedElement);

    // Update order property
    const updatedItems = newItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));

    setItems(updatedItems);
    setDraggedItem(null);
    setDragOverIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDragOverIndex(null);
  };

  useEffect(() => {
    handleColumns(items);
  }, [handleColumns, items]);

  return (
    <div style={styles.container}>
      <div style={styles.disabledFields}>
        <Checkbox defaultChecked={true} disabled>
          {t("testRecords.columnFlowID")}
        </Checkbox>
        <br />
        <br />
        <Checkbox defaultChecked={true} disabled>
          {t("testRecords.columnDateTime")}
        </Checkbox>
        <br />
        <br />
        <Checkbox defaultChecked={true} disabled>
          {t("testRecords.columnTest")}
        </Checkbox>
        <br />
        <br />
        <Checkbox defaultChecked={true} disabled>
          {t("testRecords.columnTestResult")}
        </Checkbox>
        <br />
        <br />
      </div>
      <div style={styles.listContainer}>
        {items &&
          items.map((item, index) => {
            let itemStyle = { ...styles.listItem };

            if (dragOverIndex === index) {
              itemStyle = { ...itemStyle, ...styles.listItemDragOver };
            }

            if (draggedItem?.id === item.id) {
              itemStyle = { ...itemStyle, ...styles.listItemDragging };
            }

            return (
              <React.Fragment key={item.id}>
                <div
                  draggable
                  onDragStart={e => handleDragStart(e, item)}
                  onDragOver={e => handleDragOver(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={e => handleDrop(e, index)}
                  onDragEnd={handleDragEnd}
                  style={itemStyle}
                  onMouseEnter={e => {
                    if (!draggedItem) {
                      e.currentTarget.style.boxShadow =
                        styles.listItemHover.boxShadow;
                    }
                  }}
                  onMouseLeave={e => {
                    if (!draggedItem) {
                      e.currentTarget.style.boxShadow = "none";
                    }
                  }}
                >
                  {/* Drag Handle */}
                  <div
                    style={styles.dragHandle}
                    onMouseEnter={e => {
                      e.currentTarget.style.color =
                        styles.dragHandleHover.color;
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.color = styles.dragHandle.color;
                    }}
                  >
                    <GripVertical size={16} />
                  </div>

                  {/* Toggle Checkbox */}
                  <Checkbox
                    onClick={() => toggleEnabled(item.id)}
                    checked={item.enabled}
                  />

                  {/* Item Name */}
                  <span>{item.name}</span>
                </div>

                {/* Add separator after QR Code (index 2) */}
                {index === 2 && <div style={styles.separator}></div>}
              </React.Fragment>
            );
          })}
      </div>
    </div>
  );
};

export default DraggableList;
